module.exports = __webpack_public_path__ + "web-icons.e3d7fc87c26eb0220eb7.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/web-icons/web-icons.ttf?v=0.2.3
// module id = ../../../../../src/assets/fonts/web-icons/web-icons.ttf?v=0.2.3
// module chunks = styles